export enum ActionType {
  TRAFFIC_FLOW_MANAGEMENT = "Traffic Flow Management",
  EQUIPMENT_MANAGEMENT = "Equipment Management",
  MESSAGE_SIGN_MANAGEMENT = "Message Sign Management",
  LANE_MANAGEMENT = "Lane Management",
  OTHER = "Other",
}
